import { useNavigate, useLocation } from '@remix-run/react';
import { useAuth } from '~/lib/auth-context';
import { LogoUI } from './LogoUI';

type LogoVariant = 'minimal' | 'expanded';

interface LogoProps {
  size?: number;
  withLink?: boolean;
  className?: string;
  variant?: LogoVariant;
  color?: 'black' | 'white';
}

const LogoWithNavigation = ({
  size = 32,
  className,
  variant = 'minimal',
  color = 'black',
}: Omit<LogoProps, 'withLink'>) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();

  const handleLogoClick = async (e: React.MouseEvent) => {
    e.preventDefault();

    if (!user) {
      navigate('/');
      return;
    }

    if (location.pathname === '/dashboard') {
      return;
    }

    navigate('/dashboard');
  };

  return (
    <LogoUI
      size={size}
      className={className}
      withLink
      variant={variant}
      color={color}
      onClick={handleLogoClick}
    />
  );
};

export const Logo = ({
  size = 32,
  withLink = false,
  className,
  variant = 'minimal',
  color = 'black',
}: LogoProps) => {
  if (withLink) {
    return (
      <LogoWithNavigation
        size={size}
        className={className}
        variant={variant}
        color={color}
      />
    );
  }

  return (
    <LogoUI
      size={size}
      className={className}
      variant={variant}
      color={color}
    />
  );
};
